import { all } from 'redux-saga/effects';
import asyncAction from "~/sagas/asyncAction";

export default function* () {
  yield all([
    asyncAction(),
  ]);
}